import { css } from "@emotion/react";

export const rootStyle = css`
  align-items: center;
  border-color: black;
  border-style: solid;
  border-width: 1px;
  display: flex;
  height: 30px;
  justify-content: space-between;
`;

export const disabledRootStyle = css`
  background-color: gray;
`;

export const errorRootStyle = css`
  border-color: red;
`;

export const buttonStyle = css`
  background-color: transparent;
  border: none;
  height: 20px;
  width: 20px;
  &:not(&:disabled) {
    cursor: pointer;
  }
  &:disabled {
    cursor: not-allowed;
  }
`;
